import type { ActionReducerMapBuilder } from '@reduxjs/toolkit/src/mapBuilders';
import { IAuthenticationState } from 'Redux/Slices/Authentication/AuthenticationSlice';
import { userSlice } from 'Redux/Slices/User/UserSlice';

export const authenticationSuccess = (builder: ActionReducerMapBuilder<IAuthenticationState>) => {
  builder.addCase(userSlice.actions.authenticationSuccess, (state, { payload }) => {
    state.accessToken = payload.authentication?.accessToken || state.accessToken;
    state.refreshToken = payload.authentication?.refreshToken || state.refreshToken;
    state.accessTokenExpiresAt = payload.authentication?.accessTokenExpiresAt || state.accessTokenExpiresAt;
    state.refreshTokenExpiresAt = payload.authentication?.refreshTokenExpiresAt || state.refreshTokenExpiresAt;
  })
}
